import HouseIcon from '@propertypal/shared/src/resources/icons/new-homes/house.svg?url';
import Button from '@propertypal/web-ui/src/buttons/Button';
import Link from 'next/link';
import React from 'react';
import {
  MoreDevelopmentsGroup,
  MoreDevelopmentsContent,
  MoreDevelopmentsText,
} from './ShowHomesMoreDevelopments.style.pn';

interface ShowHomesMoreDevelopmentsProps {
  totalDevelopments: number;
}

const ShowHomesMoreDevelopments: React.FC<ShowHomesMoreDevelopmentsProps> = ({ totalDevelopments }) => {
  return (
    <MoreDevelopmentsGroup data-testid="more-developments">
      <MoreDevelopmentsContent>
        <div>
          <h4>Still looking for that perfect new home?</h4>
          <MoreDevelopmentsText>
            <img src={HouseIcon.src} alt={`Browse through our list of ${totalDevelopments} developments`} />
            <p>
              Browse through our list of <b>{totalDevelopments} developments</b>
            </p>
          </MoreDevelopmentsText>
        </div>
      </MoreDevelopmentsContent>

      <Link href="/new-developments" prefetch={false}>
        <Button containerStyle={{ minWidth: 215 }}>View all Developments</Button>
      </Link>
    </MoreDevelopmentsGroup>
  );
};

export default ShowHomesMoreDevelopments;
